import { BehaviorSubject } from 'rxjs';
const DefaultState = {
	isTooltipVisible: false,
	isMouseOverTooltip: false,
	isMouseOverWidget: false,
	isWidgetActive: false,
	isLayerEnabled: true
}

class TooltipState extends BehaviorSubject{
	constructor(){
		super(Object.assign({},DefaultState));
		this._state = null;
	}
	get state(){
		if(this._state==null){
			this._state = Object.assign({},DefaultState)
		}
		return this._state;
	}

	get isTooltipVisible(){
		return this.state.isLayerVisible;
	}
	set isTooltipVisible(flag=this.state.isLayerVisible){

		if(flag!=this.state.isTooltipVisible){
			this.state.isTooltipVisible = flag;
			this.next(this.state);
		}
	}

	get isMouseOverTooltip(){
		return this.state.isMouseOverTooltip;
	}
	set isMouseOverTooltip(flag=this.state.isMouseOverTooltip){
		if(flag!=this.state.isMouseOverTooltip){
			this.state.isMouseOverTooltip = flag;
			this.next(this.state);
		}
	}
	get isMouseOverWidget(){
		return this.state.isMouseOverWidget;
	}
	set isMouseOverWidget(flag=this.state.isMouseOverWidget){
		if(flag!=this.state.isMouseOverWidget){
			this.state.isMouseOverWidget = flag;
			this.next(this.state);
		}
	}
	get isWidgetActive(){
		return this.state.isWidgetActive;
	}
	set isWidgetActive(flag=this.state.isWidgetActive){
		if(flag!=this.state.isWidgetActive){
			this.state.isWidgetActive = flag;
			this.next(this.state);
		}
	}

	get isLayerEnabled(){
		return this.state.isLayerEnabled;
	}
	set isLayerEnabled(flag= this.state.isLayerEnabled){
		if(flag!=this.state.isLayerEnabled){
			this.state.isLayerEnabled = flag;
			this.next(this.state);
		}
	}
}

export {TooltipState}